module.exports = {
  ICOMOON_EOT: require("./fonts/icomoon/icomoon.eot"),
  ICOMOON_TTF: require("./fonts/icomoon/icomoon.ttf"),
  ICOMOON_SVG: require("./fonts/icomoon/icomoon.svg"),
  ICOMOON_WOFF: require("./fonts/icomoon/icomoon.woff"),
  FAVICON: require("./images/favicon.ico"),
  NO_IMAGE: require("./images/noimage.png"),
  SPINNER: require("./images/spinner.gif")
};



// WEBPACK FOOTER //
// ./src/plugins/tfs/platformConfigs/static.js